import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  NgZone,
  ViewChild,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../service/admin.service";
import { UtilService } from "../../service/util.service";
import * as constants from "../../app.constants";
import { NotificationsService } from "angular2-notifications";

import { Ticket } from "../../model/ticket";
import { Category } from "../../model/category";
import { Currency } from "../../model/currency";
import { Location } from "../../model/location";

import { ErrorResponse } from "../../model/error-response";
import {} from "googlemaps";

import { FormControl } from "@angular/forms";
import { MapsAPILoader } from "@agm/core";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";

@Component({
  selector: "create-ticket",
  template: require('./create-ticket.component.html'),
  styles: [require('./create-ticket.component.css')],
})
export class CreateTicketComponent implements OnInit, AfterViewInit {
  public isNoRecurrence: string;
  public isValid = true;
  public message = "";
  public recurrModel: any = {
    week_tickets: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0 },
  };
  public dailyModel: any = {
    week_days: {},
  };
  public weeklyModel: any = {
    week_days: {},
  };
  public monthlyModel: any = {
    week_days: {},
  };

  public yearlyModel: any = {};
  public weekDaily = ["Mon", "Tue", "Wed", "Thu", "Fri"];
  public week = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  public monthdays = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
  ];
  public yearMonths = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  public ticket: Ticket; // Holds forms data
  public createNewTicket: boolean;
  public cntErrorMsg: string; // Create new ticket error message
  public formErrors: any;
  public recurrErrors: any = {};
  public categories: Category[] = constants.categories;
  public currencies: Currency[] = constants.currencies;
  public ticketTypes = {
    1: "All",
    2: "Active",
    3: "Inactive",
    4: "Fake",
  };
  public minEventDate: Date;
  public maxEventDate: Date;
  public showLoader: boolean;
  public tktModel: any;

  // Google Maps
  public latitude: number;
  public longitude: number;
  public searchControl: FormControl;
  public zoom: number;
  public alwaysTrue: boolean = true;
  ticketId: string = "";

  @ViewChild("search")
  public searchElementRef: ElementRef;
  @ViewChild("confirmViewDuplicateTicketModal")
  public confirmViewDuplicateTicketModal: ModalComponent;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public _notificationsService: NotificationsService,
    private adminService: AdminService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ) {
    // Initialize fields
    this.formErrors = {};
    this.ticket = new Ticket();
    this.ticket.category_id = this.categories[0].category_id;
    // this.ticket.category_id = this.categories[0].category_id;
    this.ticket.currency = this.currencies[0].currency;
    this.ticket.tempPrice = 0;
    this.cntErrorMsg = null;
    //this.alwaysTrue = true;
    // create search FormControl
    this.searchControl = new FormControl();
    // set google maps defaults
    this.zoom = constants.mapOptions.initialZoom;
    this.latitude = constants.mapOptions.latitude;
    this.longitude = constants.mapOptions.longitude;
  }

  public campareDates() {}

  public onchange(_event) {}

  public showModel(_event) {}

  public weekValid(week) {
    for (let i = 0; i < 7; i++) {
      if (week[i] === true) {
        return true;
      }
    }
    return false;
  }

  public weekValidTickets(week) {
    for (let i = 0; i < 7; i++) {
      if (parseInt(week[i]) > 0) {
        return true;
      }
    }
    return false;
  }

  public finalvalidate() {
    this.isValid = true;
    if (this.ticket.isRecurrable) {
      if (this.recurrModel.recurrType) {
        if (this.recurrModel.recurrType === "1") {
          if (this.dailyModel.Type) {
            if (this.dailyModel.Type === "1") {
              if (!this.dailyModel.interval || this.dailyModel.interval <= 0) {
                this.isValid = false;
                this.message = "All Fields are required and should be valid";
              }
            }
          } else {
            this.isValid = false;
            this.message = "Select Subtype";
          }
        } else if (this.recurrModel.recurrType === "2") {
          if (
            !this.weeklyModel.interval ||
            this.weeklyModel.interval <= 0 ||
            !this.weekValid(this.weeklyModel.week_days)
          ) {
            this.isValid = false;
            this.message = "All Fields are required and should be valid";
          }
        } else if (this.recurrModel.recurrType === "3") {
          if (this.monthlyModel.Type) {
            if (this.monthlyModel.Type === "1") {
              if (
                !this.monthlyModel.intervalType1 ||
                this.monthlyModel.intervalType1 <= 0 ||
                !this.monthlyModel.month_day
              ) {
                this.isValid = false;
                this.message = "All Fields are required and should be valid";
              }
            } else {
              if (
                !this.monthlyModel.intervalType2 ||
                this.monthlyModel.intervalType2 <= 0 ||
                !this.monthlyModel.month_week_day ||
                !this.monthlyModel.week_no
              ) {
                this.isValid = false;
                this.message = "All Fields are required and should be valid";
              }
            }
          } else {
            this.isValid = false;
            this.message = "Select Subtype";
          }
        } else if (this.recurrModel.recurrType === "4") {
          if (this.yearlyModel.Type) {
            if (this.yearlyModel.Type === "1") {
              if (
                !this.yearlyModel.interval ||
                this.yearlyModel.interval <= 0 ||
                !this.yearlyModel.month_day ||
                !this.yearlyModel.year_monthType1
              ) {
                this.isValid = false;
                this.message = "All Fields are required and should be valid";
              }
            } else {
              if (
                !this.yearlyModel.interval ||
                this.yearlyModel.interval <= 0 ||
                !this.yearlyModel.month_week_day ||
                !this.yearlyModel.year_monthType2 ||
                !this.yearlyModel.week_no
              ) {
                this.isValid = false;
                this.message = "All Fields are required and should be valid";
              }
            }
          } else {
            this.isValid = false;
            this.message = "Select Subtype";
          }
        }
        // if (!this.weekValid(this.recurrModel.week_tickets)) {
        //   this.isValid = false;
        //   this.message = 'Weekly Tickets are required and should be valid';
        // }
      } else {
        this.isValid = false;
        this.message = "Select Type";
      }
    }

    // if (this.isValid) {
    //   document.getElementById('close-modal').click();
    // }
  }

  public calcbody() {
    const weektickets = [];
    const weekdays = [];
    const body: any = {};
    if (this.recurrModel.recurrType === "1") {
      if (this.dailyModel.Type === "1") {
        body["interval"] = this.dailyModel.interval;
      } else {
        body["week_days"] = ["1", "2", "3", "4", "5"];
      }
    } else if (this.recurrModel.recurrType === "2") {
      body["interval"] = this.weeklyModel.interval;
      for (let i = 0; i < 7; i++) {
        if (this.weeklyModel.week_days[i] === true) {
          weekdays.push((i + 1).toString());
        }
      }
      body["week_days"] = weekdays;
    } else if (this.recurrModel.recurrType === "3") {
      if (this.monthlyModel.Type === "1") {
        body["interval"] = this.monthlyModel.intervalType1;
        body["month_day"] = parseInt(this.monthlyModel.month_day);
      } else {
        body["interval"] = this.monthlyModel.intervalType2;
        body["month_week_day"] = parseInt(this.monthlyModel.month_week_day);
        body["week_no"] = parseInt(this.monthlyModel.week_no);
      }
    } else if (this.recurrModel.recurrType === "4") {
      if (this.yearlyModel.Type === "1") {
        body["interval"] = this.yearlyModel.interval;
        body["month_day"] = parseInt(this.yearlyModel.month_day);
        body["year_month"] = parseInt(this.yearlyModel.year_monthType1);
      } else {
        body["interval"] = this.yearlyModel.interval;
        body["month_week_day"] = parseInt(this.yearlyModel.month_week_day);
        body["year_month"] = parseInt(this.yearlyModel.year_monthType2);
        body["week_no"] = parseInt(this.yearlyModel.week_no);
      }
    }

    for (let i = 0; i < 7; i++) {
      if (this.recurrModel.week_tickets[i] === "") {
        weektickets.push(0);
      } else {
        weektickets.push(parseInt(this.recurrModel.week_tickets[i]));
      }
    }
    if (this.ticket.UnlimitedRecurrable) {
      delete body["week_tickets"];
    } else {
      body["week_tickets"] = weektickets;
    }
    return body;
  }

  public validateReccuranceModal(): boolean {
    this.finalvalidate();
    if (this.isValid) {
      delete this.recurrErrors["isRecurrable"];
      return true;
    } else {
      this.recurrErrors["isRecurrable"] = this.message;
      return false;
    }
  }

  public validateWeekTickets() {
    if (!this.weekValidTickets(this.recurrModel.week_tickets)) {
      this.recurrErrors["weektickets"] =
        "All values of contingency tickets cannot be zero";
      return false;
    } else {
      delete this.recurrErrors["weektickets"];
      return true;
    }
  }

  public validateRecurrStartTime() {
    if (this.ticket.recurrableStartTime) {
      delete this.recurrErrors["recurrableStartTime"];
      return true;
    } else {
      this.recurrErrors["recurrableStartTime"] = "This field is required";
      return false;
    }
  }

  public validateRecurrEndTime() {
    if (
      this.ticket.recurrableEndTime &&
      this.ticket.recurrableEndTime > this.ticket.recurrableStartTime
    ) {
      delete this.recurrErrors["recurrableEndTime"];
      return true;
    } else {
      if (!this.ticket.recurrableEndTime) {
        this.recurrErrors["recurrableEndTime"] = "This field is required";
      } else if (
        !(this.ticket.recurrableEndTime > this.ticket.recurrableStartTime)
      ) {
        this.recurrErrors["recurrableEndTime"] =
          "Event End Time field should be greater than Event Start Time";
      }
      return false;
    }
  }

  public validateRecurrStartDate() {
    if (this.ticket.recurrableStartDate) {
      delete this.recurrErrors["recurrableStartDate"];
      return true;
    } else {
      this.recurrErrors["recurrableStartDate"] = "This field is required";
      return false;
    }
  }

  public validateRecurrEndType() {
    if (this.isNoRecurrence) {
      delete this.recurrErrors["recurrableEndType"];
      return true;
    } else {
      this.recurrErrors["recurrableEndType"] = "This field is required";
      return false;
    }
  }

  public validateRecurrEndDate() {
    if (this.isNoRecurrence !== "1") {
      delete this.recurrErrors["recurrableEndDate"];
      return true;
    } else {
      if (
        this.ticket.recurrableEndDate &&
        this.ticket.recurrableEndDate > this.ticket.recurrableStartDate
      ) {
        delete this.recurrErrors["recurrableEndDate"];
        return true;
      } else {
        if (!this.ticket.recurrableEndDate) {
          this.recurrErrors["recurrableEndDate"] = "This field is required";
        } else if (
          !(this.ticket.recurrableEndDate > this.ticket.recurrableStartDate)
        ) {
          this.recurrErrors["recurrableEndDate"] =
            "Recurrence End Date should be greater than Recurrence Start Date";
        }
        return false;
      }
    }
  }

  public validateRecurrNo() {
    if (this.isNoRecurrence !== "2") {
      delete this.recurrErrors["noOfRecurrance"];
      return true;
    } else {
      if (this.ticket.noOfRecurrance && this.ticket.noOfRecurrance > 0) {
        delete this.recurrErrors["noOfRecurrance"];
        return true;
      } else {
        if (!this.ticket.noOfRecurrance) {
          this.recurrErrors["noOfRecurrance"] = "This field is required";
        } else if (!(this.ticket.noOfRecurrance > 0)) {
          this.recurrErrors["noOfRecurrance"] =
            "This field should be greater than 0";
        }
        return false;
      }
    }
  }

  public ngOnInit(): void {
    this.formErrors = {};
    this.minEventDate = new Date();
    this.minEventDate.setDate(this.minEventDate.getDate() + 1);
    this.minEventDate.setHours(0);
    this.minEventDate.setMinutes(0);
    this.minEventDate.setSeconds(0);

    this.maxEventDate = new Date();
    this.maxEventDate.setFullYear(this.maxEventDate.getFullYear() + 1);
  }

  public ngAfterViewInit(): void {
    // After view init
    this.loadPlaces();
    // set current position
    // this.setCurrentPosition();
  }

  public onDateChange(_event, _type) {}

  public formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) {
      month = "0" + month;
    }
    if (day.length < 2) {
      day = "0" + day;
    }

    return [year, month, day].join("-");
  }

  public onDateChanged(event, _type) {
    event.setSeconds(0);
    event.setMilliseconds(0);
  }

  public cancelCreateNewTicket(): void {
    let params = {
      tkttype: 2,
    };
    this.router.navigate(["/manage/tickets"], { queryParams: params });
    // this.ticket = null;
  }

  public setUnlimitedNoOfTickets(tkt: Ticket): void {
    delete tkt["number_of_tickets"];
    delete tkt["tempPrice"];

    this.validateNoOfTickets();
  }

  public validateForm(): boolean {
    let valid: boolean = true;
    valid = this.validateTitle() ? valid : false;
    valid = this.validateEventUrl() ? valid : false;

    valid = this.validateLocation() ? valid : false;
    valid = this.validatePrice() ? valid : false;
    valid = this.validateTicketImage() ? valid : false;
    valid = this.validatePickUpAddress() ? valid : false;
    valid = this.validateDescription() ? valid : false;

    if (this.ticket.isRecurrable) {
      valid = this.validateReccuranceModal() ? valid : false;
      valid = this.validateRecurrStartTime() ? valid : false;
      valid = this.validateRecurrEndTime() ? valid : false;
      valid = this.validateRecurrStartDate() ? valid : false;
      valid = this.validateRecurrEndType() ? valid : false;
      valid = this.validateRecurrEndDate() ? valid : false;
      valid = this.validateRecurrNo() ? valid : false;
      if (!this.ticket.UnlimitedRecurrable) {
        valid = this.validateWeekTickets() ? valid : false;
      }
    } else {
      this.recurrErrors = {};
      if (this.ticket.eventMoreThanOneDay) {
        //valid = this.validateStartDate() ? valid : false;
        valid = this.validateEndDate() ? valid : false;
      } else {
        //valid = this.validatePurchaseBeforeDate() ? valid : false;
      }
      valid = this.validateEventDate() ? valid : false;

      if (!this.validateNoOfTickets()) {
        // Validation failed
        valid = false;
        this.formErrors["number_of_tickets"] = "This field is required";
      }
    }
    // valid = this.validatePickUpAddress() ? valid : false; // Address is optional

    if (valid) {
      this.cntErrorMsg = null;
    } else {
      this.cntErrorMsg = "Some fields are not valid";
    }
    return valid;
  }

  public saveNewTicket(): void {
    if (!this.validateForm()) {
      // Validation failed
      return;
    }

    let model = {
      title: this.ticket.title,
      purchase_before_date: null,
      location: this.ticket.location,
      category: +this.ticket.category_id,
      category_id: +this.ticket.category_id,
      price: {
        per_ticket: +this.ticket.tempPrice,
        currency: this.ticket.currency,
      },
      event_url: this.ticket.event_url,
      image: this.ticket.image ? this.ticket.image.image_id : null,
      image_id: this.ticket.image ? this.ticket.image.image_id : null,
      pick_up_address: this.ticket.pick_up_address,
      description: this.ticket.description,
      is_free: this.alwaysTrue,
    };
    model["location"]["coords"] = {
      longitude: this.ticket.location.long,
      latitude: this.ticket.location.lat,
    };
    if (this.alwaysTrue) {
      model.price.per_ticket = 0;
    }

    this.tktModel = model;

    if (this.ticket.isRecurrable) {
      const body = this.calcbody();
      Object.keys(body).forEach((key) => {
        model[key] = body[key];
      });
      model["recurrence_start_date"] = this.formatDate(
        this.ticket.recurrableStartDate
      );
      model["recurrence_start_time"] = new Date(this.ticket.recurrableStartTime)
        .toISOString()
        .split("T")[1];
      model["recurrence_end_time"] = new Date(this.ticket.recurrableEndTime)
        .toISOString()
        .split("T")[1];

      if (this.isNoRecurrence === "2") {
        model["no_of_recurrence"] = parseInt(this.ticket.noOfRecurrance);
      } else if (this.isNoRecurrence === "1") {
        model["recurrence_end_date"] = this.formatDate(
          this.ticket.recurrableEndDate
        );
      } else {
        model["no_end_date"] = true;
      }
      model["recurrence_pattern"] = parseInt(this.recurrModel.recurrType);
    } else {
      if (this.ticket.unlimitedNoOfTickets) {
        model["unlimitedNoOfTickets"] = true;
        model["number_of_tickets"] = null;
      } else {
        model["unlimitedNoOfTickets"] = false;
        model["number_of_tickets"] = this.ticket.number_of_tickets;
      }
      if (this.ticket.eventMoreThanOneDay) {
        //model['start_date']=this.ticket.start_date;
        model["end_date"] = this.ticket.end_date;
        model["purchase_before_date"] = null;
      } else {
        model["purchase_before_date"] = this.ticket.purchase_before_date;
      }
      model["event_date"] = this.ticket.event_date;
    }

    // if (5==5)return;
    this.cntErrorMsg = null;
    this.formErrors = {};
    this.recurrErrors = {};
    this.showLoader = true;

    let url = constants.URLs.createNewTicket.replace(
      "{user_id}",
      localStorage.getItem("userId")
    );

    if (this.ticket.isRecurrable) {
      url = url + "?is_recurrence_ticket=True";
    }

    this.adminService
      .postCall(url, model, true)
      .then((res) => {
        this.showLoader = false;
        this.adminService.showSuccessToast(constants.messages.createNewTicket);
        let params = {
          tkttype: 5,
        };
        this.router.navigate(["/manage/tickets"], { queryParams: params });
      })
      .catch((error: any) => {
        this.showLoader = false;
        try {
          let errorRes: ErrorResponse = error.json();
          // Use in opertor to check if key the exists in an object
          if (errorRes.error_location in model) {
            this.cntErrorMsg = "Invalid input";
            if (typeof errorRes.error_msg === "string") {
              this.cntErrorMsg = errorRes.error_msg || "Invalid input";
              this.formErrors[errorRes.error_location] = errorRes.error_msg;
            } else {
              this.formErrors[errorRes.error_location] =
                "Please provide valid input";
            }
          } else {
            this.cntErrorMsg =
              errorRes.error_msg || constants.messages.serverError;
          }

          if ("ticket_id" in errorRes) {
            this.ticketId = errorRes["ticket_id"];
            this.confirmViewDuplicateTicketModal.open();
          }
        } catch (e) {
          this.cntErrorMsg = error.message
            ? error.message
            : constants.messages.serverError;
          this.adminService.showErrorToast(this.cntErrorMsg);
        }
      });
  }

  // public isPrice(event) {
  //   // ^\d{0,6}(\.\d{1,2})?$
  //   return UtilService.isDigit(event);
  // }
  public isPrice(num) {
    let re = /^\d{0,8}(\.\d{1,2})?$/;
    return new RegExp(re).test(num);
  }

  public isDigit(event): boolean {
    return UtilService.isDigit(event);
  }

  public onNumberOfTicketsChangeHandler(event) {
    if (this.ticket.unlimitedNoOfTickets) {
      this.ticket.unlimitedNoOfTickets = false;
    }

    return UtilService.isDigit(event);
  }

  public onPriceChangeHandler(event) {
    if (this.ticket.unlimitedNoOfTickets) {
      this.ticket.unlimitedNoOfTickets = false;
      this.ticket.number_of_tickets = 4;
    }

    return UtilService.isNumber(event);
  }

  public isUrl(url: string): boolean {
    const urlRegex =
      /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

    return new RegExp(urlRegex).test(url);
  }

  public appendFormImage(event): void {
    if (event.target.files && event.target.files[0]) {
      // Validate selected image dimension and Preview picture
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.ticket.previewImageUrl = e.target.result;
        this.uploadTicketImage(event.target.files[0]); // TODO UNCOMMENT ME
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      this.ticket.previewImageUrl = null;
      this.ticket.image = null;
    }
  }

  public uploadTicketImage(file: any): void {
    this.cntErrorMsg = null;
    let url = constants.URLs.uploadTicketImage;
    let form = new FormData();
    form.append("image[file]", file);
    this.adminService
      .uploadImages(url, form)
      .then((res) => {
        this.ticket.image = res;
        this.validateTicketImage();
        // this.adminService.showSuccessToast(constants.messages.uploadTicketImage);
      })
      .catch((error: any) => {
        try {
          this.cntErrorMsg =
            error.json().error_msg || constants.messages.serverError;
        } catch (e) {
          this.cntErrorMsg = error.message
            ? error.message
            : constants.messages.serverError;
        }
        this.adminService.showErrorToast(this.cntErrorMsg);
      });
  }

  public validateTitle(): boolean {
    if (this.ticket.title && this.ticket.title.length > 0) {
      if (this.ticket.title.length <= 50) {
        delete this.formErrors["title"];
        this.checkOtherErrors();
        return true;
      } else {
        this.formErrors["title"] = "Title can contain only 50 characters";
        return false;
      }
    } else {
      this.formErrors["title"] = "This field is required";
      return false;
    }
  }

  public validateEventUrl(): boolean {
    if (this.ticket.title && this.ticket.title.length > 0) {
      if (this.isUrl(this.ticket.event_url)) {
        delete this.formErrors["event_url"];
        this.checkOtherErrors();
        return true;
      } else {
        this.formErrors["event_url"] =
          "This is not a valid url. Url should start with `https://`. Example: http://google.com .";
        return false;
      }
    } else {
      this.formErrors["event_url"] = "This field is required";
      return false;
    }
  }

  public validateEventDate(): boolean {
    if (this.ticket.event_date) {
      delete this.formErrors["event_date"];
      this.checkOtherErrors();
      return true;
    } else {
      this.formErrors["event_date"] = "This field is required";
      return false;
    }
  }

  //public validateStartDate(): boolean {
  //  if (this.ticket.start_date) {
  //    delete this.formErrors['start_date'];
  //    this.checkOtherErrors();
  //    return true;
  //  } else {
  //    this.formErrors['start_date'] = 'This field is required';
  //    return false;
  //  }
  //}

  public validateEndDate(): boolean {
    if (this.ticket.end_date) {
      delete this.formErrors["end_date"];
      this.checkOtherErrors();
      return true;
    } else {
      this.formErrors["end_date"] = "This field is required";
      return false;
    }
  }

  public validatePurchaseBeforeDate(): boolean {
    if (this.ticket.purchase_before_date) {
      delete this.formErrors["purchase_before_date"];
      this.checkOtherErrors();
      return true;
    } else {
      this.formErrors["purchase_before_date"] = "This field is required";
      return false;
    }
  }

  public validateNoOfTickets(): boolean {
    if (
      !this.ticket.unlimitedNoOfTickets &&
      (this.ticket.number_of_tickets === undefined ||
        this.ticket.number_of_tickets < 1)
    ) {
      return false;
    } else {
      delete this.formErrors["number_of_tickets"];
      this.checkOtherErrors();
      return true;
    }
  }

  public validateLocation(): boolean {
    if (
      this.ticket.location &&
      this.ticket.location.address &&
      this.ticket.location.address.length > 0
    ) {
      delete this.formErrors["location"];
      this.checkOtherErrors();
      return true;
    } else {
      this.formErrors["location"] = "This field is required";
      return false;
    }
  }

  public validatePrice(): boolean {
    if (
      this.ticket.tempPrice !== undefined &&
      this.isPrice(this.ticket.tempPrice) &&
      UtilService.validateNumber(this.ticket.tempPrice) &&
      (this.ticket.tempPrice + "").length > 0
    ) {
      delete this.formErrors["price"];
      this.checkOtherErrors();
      return true;
    } else {
      this.formErrors["price"] =
        "Price should be max 8 digits before decimal and 2 digits after decimal";
      return false;
    }
  }

  public validateTicketImage(): boolean {
    if (this.ticket.image && this.ticket.image.image_id) {
      delete this.formErrors["image"];
      this.checkOtherErrors();
      return true;
    } else {
      this.formErrors["image"] = "This field is required";
      return false;
    }
  }

  public validatePickUpAddress(): boolean {
    if (
      this.ticket.pick_up_address &&
      this.ticket.pick_up_address.length > 100
    ) {
      this.formErrors["pick_up_address"] =
        "Pickup address can contain only 100 characters";
      return false;
    } else {
      delete this.formErrors["pick_up_address"];
      this.checkOtherErrors();
      return true;
    }
  }

  public validateDescription(): boolean {
    if (this.ticket.description && this.ticket.description.length > 5000) {
      this.formErrors["description"] =
        "Description can contain only 5000 characters";
      return false;
    } else {
      delete this.formErrors["description"];
      this.checkOtherErrors();
      return true;
    }
  }

  public checkOtherErrors(): void {
    if (Object.keys(this.formErrors).length === 0) {
      // There are no other errors
      this.cntErrorMsg = null;
    }
  }

  private loadPlaces(): void {
    // load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          // types: ['address']
        }
      );
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          // get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            this.ticket.location = null;
            return;
          }

          // console.debug(place);

          let location = new Location();
          // location.name = place['name'];
          // location.address = place['formatted_address'];
          location.name = this.searchElementRef.nativeElement.value;
          location.address = this.searchElementRef.nativeElement.value;
          location.lat = place.geometry.location.lat();
          location.long = place.geometry.location.lng();
          this.ticket.location = location;

          // set latitude, longitude and zoom
          this.latitude = location.lat;
          this.longitude = location.long;
          this.zoom = constants.mapOptions.searchZoom;
        });
      });
    });
  }

  private setCurrentPosition(): void {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = constants.mapOptions.searchZoom;
      });
    }
  }

  public viewDuplicateTicketModal(ticketId): void {
    this.confirmViewDuplicateTicketModal.close();
    window.open(
      constants.serverUrl + "/manage/tickets?tkttype=5&tktid=" + ticketId,
      "_blank"
    );
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/manage/create-ticket/create-ticket.component.ts